import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui, rydeColors } from "@ryde/theme";

export const NeighborAreasTemplateWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "neighbor-areas-template-wrapper",
  },
)`
  display: flex;
  flex-direction: column;
  gap: 14px;
  border: 1px dashed ${greyMui._400};
  border-radius: 5px;
  padding: 12px;

  .NeighborAreasSettings__container {
    display: flex;
    flex-direction: column;
    gap: 14px;

    &[data-inner-editing="true"] {
      .display-mode {
        filter: blur(3px) grayscale(100%) !important;
        pointer-events: none !important;
        transition: filter 0.55s ease-out;
      }

      .NeighborAreasSettings-AddItem .MuiButton-root {
        filter: blur(3px) grayscale(100%);
        pointer-events: none;
        transition: filter 0.55s ease-out;
      }
    }
  }

  .NeighborAreasSettings-AddItem {
    .MuiButton-root {
      line-height: 1.75;
    }
  }

  .NeighborAreasSettings-CollapseSection {
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow: hidden;
    height: 100%;
  }

  .NeighborAreasSettings-Header {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 80px;
    align-items: center;
    border: 1px solid ${greyMui._200};
    border-radius: 5px;
    padding: 6px;
    background-color: ${rydeColors.smoke};
    transition: filter 0.55s ease-out;
  }
  .NeighborAreasSettings-List {
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .NeighborAreasSettings-GroupTitle {
    padding: 6px;
    font-weight: bold;
    border: 1px solid ${greyMui._200};
    border-radius: 5px;
    background-color: ${rydeColors.smoke};
    transition: filter 0.55s ease-out;
  }

  .NeighborAreasSettings-Item {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 80px;
    grid-template-rows: 1fr 1fr 1fr;
    border: 1px solid ${greyMui._200};
    padding: 6px;
    border-radius: 4px;
    transition: filter 0.55s ease-out;
  }

  .NeighborAreasSettings-ItemDayGroups {
    grid-row: 2/3;
    grid-column: 1/3;
  }
  .NeighborAreasSettings-ItemDayTypes {
    grid-row: 2/3;
    grid-column: 3/5;
  }

  .NeighborAreasSettings-ItemSites {
    grid-row: 3/4;
    grid-column: 1/5;
  }

  .NeighborAreasSettings-MaxSeats {
    grid-row: 4;
    display: contents;
  }

  .NeighborAreasSettings-MaxSeats .label {
    color: ${blueGreyMui._600};
    font-size: 13px;
    grid-column: 1/4;
  }
  .NeighborAreasSettings-MaxSeats .value {
    grid-column: 4/5;
  }

  .NeighborAreasSettings-Buttons {
    grid-row: 1/4;
    grid-column: 5/6;
    display: flex;
    justify-content: center;
    align-items: center;

    > span {
      width: 40px;
      height: 40px;
    }
  }

  .NeighborAreasSettings-ItemEdit {
    box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.05);
    padding: 8px;
    border: 1px solid ${greyMui._200};
    display: grid;
    grid-template-areas:
      "area      area     area"
      "direction fromTime toTime"
      "dayGroup  dayGroup dayGroup"
      "dayType   dayType  dayType"
      "maxSeats  maxSeats maxSeats"
      "sites     sites    sites"
      "buttons   buttons  buttons";
    grid-template-columns: 90px 1fr 1fr;
    row-gap: 12px;
    column-gap: 5px;
  }

  .NeighborAreasSettings-ItemEditArea {
    grid-area: area;
  }

  .NeighborAreasSettings-ItemEditDirection {
    grid-area: direction;
  }
  .NeighborAreasSettings-ItemEditFromTime {
    grid-area: fromTime;
  }
  .NeighborAreasSettings-ItemEditToTime {
    grid-area: toTime;
  }
  .NeighborAreasSettings-ItemEditDayGroups {
    grid-area: dayGroup;
  }
  .NeighborAreasSettings-ItemEditDayTypes {
    grid-area: dayType;
  }
  .NeighborAreasSettings-ItemEditSites {
    grid-area: sites;

    .MuiFormControl-root {
      width: 100%;
    }
  }
  .NeighborAreasSettings-ItemEditMaxSeatsLabel {
    grid-area: seatsLabel;
    .MuiFormControl-root {
      width: 100%;
    }
  }
  .NeighborAreasSettings-ItemEditMaxSeats {
    grid-area: maxSeats;
  }
  .NeighborAreasSettings-ItemEditButtons {
    grid-area: buttons;
    display: flex;
    justify-content: flex-end;
  }
`;
